export default __webpack_public_path__ + "static/media/graphql.f026e547.svg";